<lib-page-layout>
  <lib-title-navbar pageHeader title="Generuj post"></lib-title-navbar>
  <div class="post-generator">
    <!-- Days Selection -->
    <div class="filter-section">
      <div class="filter-section__title">Zakres czasowy</div>
      <ion-radio-group (ionChange)="setDay($event)" class="chips-group">
        @for (item of availableDays; track item) {
          <ion-radio [value]="item" class="filter-chip"> {{ item }} {{ item === 1 ? 'dzień' : 'dni' }} </ion-radio>
        }
      </ion-radio-group>
    </div>

    <!-- Radius Selection -->
    <div class="filter-section">
      <div class="filter-section__title">Promień wyszukiwania</div>
      <ion-radio-group (ionChange)="setRadius($event)" class="chips-group">
        @for (item of availableRadiuses; track item) {
          <ion-radio [value]="item" class="filter-chip"> {{ item }} km </ion-radio>
        }
      </ion-radio-group>
    </div>

    <!-- City Selection -->
    <div class="filter-section">
      <div class="filter-section__title">Miasto</div>
      <ion-radio-group (ionChange)="setCity($event)" class="chips-group chips-group--cities">
        @for (item of availableCities(); track item) {
          <ion-radio [value]="item" class="filter-chip filter-chip--city"> {{ item }} </ion-radio>
        }
      </ion-radio-group>
    </div>

    <!-- Results Section -->
    <div class="results-section">
      <div class="results-header">
        <div class="results-count">
          <span class="results-count__number">{{ gamesCount() }}</span>
          <span class="results-count__label">gierek</span>
        </div>
        <button class="copy-btn" [class.copy-btn--disabled]="!gamesCount()" (click)="copy()">Skopiuj</button>
      </div>

      @if (gamesCount()) {
        <div class="games-preview">
          @for (game of games(); track game) {
            <div class="game-preview-item">{{ game }}</div>
          }
        </div>
      } @else {
        <div class="empty-state">
          <div class="empty-state__icon">📋</div>
          <div class="empty-state__text">Wybierz filtry aby wygenerować post</div>
        </div>
      }
    </div>
  </div>
</lib-page-layout>
